<template>
    <div>
        <div class="tours">
            <div class="tours_banner">
                <div>
                    <span>{{ $t('luxury_yacht_tours') }}</span>
                    <p>{{ $t('luxury_yacht_tours_tip') }}</p>
                </div>
            </div>
            <div class="yachts_filter">
                <div class="yachts_filter_title">{{ $t('yacht_filter') }}</div>
                <el-form class="yachts_filter_main" ref="dataForm">
                    <div class="select_date">
                        <p>{{ $t('select_date') }}</p>
                        <div>
                            <el-date-picker
                                prefix-icon="select_date_icon"
                                type="date"
                                v-model="list.select_dates"
                                :placeholder="`${dayjs(tomorrow).format('YYYY 年 MM 月 DD日')} ${
                                    weekCh[dayjs(tomorrow).format('d')]
                                }`"
                                :format="`yyyy 年 MM 月 dd 日 [${weekCh[dayjs(list.select_dates).format('d')]}]`"
                                value-format="timestamp"
                                :picker-options="pickerOptionsDate"
                                :editable="false"
                                @change="selectDate"
                                :clearable="false"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="charter_time">
                        <p>{{ $t('charter_time') }}</p>
                        <div class="charter_time_text">
                            <div class="my-slider__tooltip" :style="styles">
                                <el-button class="my-slider__tooltip-wrapper" size="mini">
                                    {{ values }}
                                </el-button>
                            </div>
                            <div class="charter_time_slider">
                                <el-slider
                                    v-model="list.charter_time"
                                    show-stops
                                    :marks="marks"
                                    :min="6"
                                    :max="23"
                                    :step="1"
                                    :show-tooltip="false"
                                    @change="timeTip"
                                ></el-slider>
                                <div class="fixedPM">12PM</div>
                            </div>
                        </div>
                    </div>
                    <div class="number_guests">
                        <p>{{ $t('number_guests') }}</p>
                        <div class="number_guests_text">
                            <div class="my-slider__tooltip" :style="style">
                                <el-button class="my-slider__tooltip-wrapper" size="mini">
                                    {{ list.number_guests }}
                                </el-button>
                            </div>
                            <el-slider
                                v-model="list.number_guests"
                                :max="45"
                                :format-tooltip="value => value"
                                :show-tooltip="false"
                                @change="numberGuests"
                            ></el-slider>
                            <p>45</p>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="tours_daily">
                <div class="tours_top">
                    <img class="banner_l2" src="@/assets/banner_l2.png" alt="" />
                    <img class="banner_l1" src="@/assets/banner_l1.png" alt="" />
                    <p>{{ $t('yacht_tours_operate_daily') }}</p>
                    <span>{{ $t('live_virtual_tour') }}</span>
                    <span class="live_virtual_tour_under">{{ $t('live_virtual_tour_under') }}</span>
                    <img class="banner_l1" src="@/assets/guide.png" alt="" />
                </div>
                <template v-if="yachtList.length !== 0">
                    <div class="tours_main">
                        <div class="tours_lists" v-for="(item, index) in yachtList" :key="index">
                            <swiper class="swiper my-swiper" :options="swiperOption">
                                <swiper-slide class="slide" v-for="(citem, cindex) in item.mediaArr" :key="cindex">
                                    <el-image
                                        style="width: 100%; height: 100%"
                                        :src="citem"
                                        fit="cover"
                                        :preview-src-list="item.mediaArr"
                                    ></el-image>
                                </swiper-slide>
                                <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                                <div class="swiper-button-prev" slot="button-prev"></div>
                                <div class="swiper-button-next" slot="button-next"></div>
                            </swiper>

                            <div class="tours_tip">
                                <div class="tours_tip_t">
                                    <div class="tours_tip_name">
                                        <span>
                                            <img src="@/assets/weather0.png" v-if="item.timeType === 0" />
                                            <img src="@/assets/weather1.png" v-else-if="item.timeType === 1" />
                                            <img src="@/assets/weather2.png" v-else-if="item.timeType === 2" />
                                            <img src="@/assets/weather3.png" v-else-if="item.timeType === 3" />
                                            <img
                                                src="@/assets/weather4.png"
                                                v-else-if="item.timeType === 4"
                                                style="width: 12px"
                                            />{{
                                                item.timeType === 0
                                                    ? '清晨'
                                                    : item.timeType === 1
                                                    ? '早上'
                                                    : item.timeType === 2
                                                    ? '中午'
                                                    : item.timeType === 3
                                                    ? '傍晚'
                                                    : '深夜'
                                            }}</span
                                        >
                                    </div>
                                    <div class="tours_tip_time">
                                        <img src="@/assets/clock.png" alt="" />
                                        <span>{{ item.startTime }}-{{ item.endTime }}</span>
                                    </div>
                                    <div class="tours_tip_price">
                                        <span>{{ $t('adult') }}: </span>
                                        <span>AED {{ item.adultPrice }}</span>
                                    </div>
                                    <div class="tours_tip_price">
                                        <span>{{ $t('child') }}: </span>
                                        <span>AED {{ item.childPrice }}</span>
                                    </div>
                                </div>
                                <div class="tours_tip_b">
                                    <p>{{ item.remark }}</p>
                                    <el-button class="tours_tip_btn" @click="book(index)">{{
                                        $t('book_instantly')
                                    }}</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <empty v-else :emptyImage="require('@/assets/yacht_tours_nodata.svg')"></empty>
            </div>
            <div class="tours_hurry">
                <p v-html="$t('yacht_code', { code: 'YACHTLIFE' })"></p>
                <div></div>
            </div>
            <div class="tours_info">
                <div class="tours_info_list">
                    <p>{{ info_list.experience.title }}</p>
                    <el-carousel class="tours_experience_imgs" trigger="click" :autoplay="false">
                        <el-carousel-item v-for="(item, index) in info_list.experience.img" :key="index">
                            <img :src="item" alt="" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="tours_info_list tours_map_list">
                    <p>{{ info_list.map.title }}</p>
                    <video :src="info_list.map.img" autoplay loop muted :controls="false"></video>
                </div>
                <div class="tours_info_lists">
                    <p>{{ info_list.highlights.title }}</p>
                    <el-carousel class="highlights_imgs" trigger="click" height="494px" :autoplay="false">
                        <el-carousel-item v-for="(item, index) in info_list.highlights.img" :key="index">
                            <img :src="item" alt="" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="tours_FAQ">
                    <p>{{ info_list.FAQ.title }}</p>
                    <el-collapse accordion>
                        <el-collapse-item v-for="(item, index) in info_list.FAQ.map_lists" :key="index">
                            <template slot="title">{{ item.question }}</template>
                            <div>{{ item.answer }}</div>
                        </el-collapse-item>
                    </el-collapse>
                    <span class="FAQ_question">{{ info_list.FAQ.map_question }}</span>
                </div>
            </div>
        </div>
        <el-dialog class="book_dialog" :visible.sync="tour_book" :append-to-body="true" :lock-scroll="false">
            <tourbook
                @close_submit="close_submit"
                @tour_submit="tour_submit"
                :tour_book="tour_book"
                :options="diaLogOptions"
            />
        </el-dialog>
    </div>
</template>
<script>
import tourbook from '@/components/tour_booking.vue'
import Empty from '@/components/Empty.vue'
import mixin from '@/mixin/Tours'
export default {
    mixins: [mixin],
    components: {
        tourbook,
        Empty,
    },
    methods: {
        book(index) {
            const item = this.yachtList[index]
            const { startTime, endTime, rentDate, productId, takeOrderType, rentType, rentTimeDetailId } = item
            this.diaLogOptions = {
                startTime,
                endTime,
                rentDate,
                productId,
                takeOrderType,
                rentType,
                rentTimeDetailId,
                statusName:
                    item.timeType === 0
                        ? '清晨'
                        : item.timeType === 1
                        ? '早上'
                        : item.timeType === 2
                        ? '中午'
                        : item.timeType === 3
                        ? '傍晚'
                        : '深夜',
            }
            this.tour_book = true
        },
    },
}
</script>
<style scoped src="@/styles/super.css"></style>
<style lang="scss" src="@/styles/yachts_tours.scss" scoped></style>
<style lang="less" scoped>
.tours_tip_name {
    & > span {
        position: relative;
        img {
            position: absolute;
            left: -20px;
            top: 15px;
            height: auto;
        }
    }
}
.my-slider__tooltip {
    text-align: left;
    box-sizing: border-box;

    .my-slider__tooltip-wrapper {
        background: url(@/assets/slide_tolips.png) no-repeat;
        height: 22px;
        // width: 45px;
        padding: 0 4px;
        transform: translateX(-90%);
        color: #ffcc69;
        border: none;
        background-size: 45px 22px;
        line-height: 22px;
    }

    .el-button--mini,
    .el-button--mini.is-round {
        padding: 0;
        margin-bottom: 6px;
    }
}
.tours_daily {
    min-height: 500px;
}
.charter_time_text {
    .my-slider__tooltip {
        text-align: left;
        box-sizing: border-box;

        .my-slider__tooltip-wrapper {
            background: url(@/assets/slide_tolips.png) no-repeat;
            height: 22px;
            // width: 45px;
            padding: 0 4px;
            transform: translateX(-90%);
            color: #ffcc69;
            border: none;
            background-size: 45px 22px;
            line-height: 22px;
        }

        .el-button--mini,
        .el-button--mini.is-round {
            padding: 0;
            margin-bottom: 6px;
        }
    }
}

.number_guests_text {
    .my-slider__tooltip {
        text-align: left;
        padding-top: 8px;
        box-sizing: border-box;

        .my-slider__tooltip-wrapper {
            background: url(@/assets/slide_tolip.png) no-repeat;
            height: 22px;
            width: 19px;
            transform: translateX(-90%);
            color: #ffcc69;
            border: none;
        }

        .el-button--mini,
        .el-button--mini.is-round {
            padding: 0;
            margin-bottom: 4px;
        }
    }
}
.swiper-pagination {
    right: 0;
    left: 0;
    bottom: 6px;
    ::v-deep .swiper-pagination-bullet {
        width: 15px;
        height: 4px;
        border-radius: 4px;
        border: 1px solid #ffffff7a;
        margin: 0 2px;
        background-color: #eee;
    }
    ::v-deep .swiper-pagination-bullet-active {
        background-color: #fff;
    }
}
.charter_time_slider {
    position: relative;
    .fixedPM {
        position: absolute;
        bottom: -19px;
        right: -2px;
        font-size: 10px;
        color: #d9b061;
    }
}
::v-deep .charter_time_text .el-slider__runway {
    margin-right: 10px;
    width: 330px;
}
/deep/.el-empty__image {
    margin-left: 130px;
    img {
        width: 684px !important;
    }
}
/deep/.el-empty__description {
    p {
        color: #f1f1f1 !important;
        font-size: 30px;
        margin-top: 10px;
    }
}
/deep/.el-carousel__indicators--horizontal {
    display: block;
}
.swiper-pagination {
    display: flex;
    justify-content: center;

    /deep/.my-bullet {
        width: 30px;
        height: 2px;
        background-color: #fff;
        // border-radius: 50%;
        display: block;
        margin: 0 5px;
        opacity: 0.48;
    }

    /deep/.my-bullet-active {
        background-color: #fff;
        opacity: 1;
    }
}
/deep/.tours_FAQ {
    .el-icon-arrow-right {
        font-size: 12px;
    }
}
</style>
